'use client'; // 声明为客户端组件
import Util from "@/Master/Util";
import RouterMgr from "@/Core/RouterMgr";
import DataMgr from "@/Fwk/DataMgr";
import ChannelMgr from "@/Fwk/Channel/ChannelMgr";

export default class UtilUrl {
    static tag = '[UtilUrl]';
    static initData = 'UrlInitUrlData';
    static params: URLSearchParams;
    static URL: URL;


    static Init() {
        this.URL = new URL(window.location.href);
        this.params = this.URL.searchParams;
        const searchParamsStr = this.params.toString();
        if (Util.isLog) {
            console.log(this.tag, 'Init params:', this.params.toString());
        }
        const initData = DataMgr.getStorage(UtilUrl.initData);
        if (searchParamsStr && !initData) {
            DataMgr.setStorage(UtilUrl.initData, searchParamsStr);
        }
    }

    static get getOpenUrl(){
        return window.location.href;
    };

    // 获取单个参数的值
    static getParam(key: string) {
        const value = this.params?.get(key);
        if (value !== undefined && value) {
            return value;
        }
        return '';
    }

    // 获取所有参数，返回一个对象
    static get getAllParams(): Record<string, string> {
        let paramsObject: Record<string, string> = {};
        const sss = Array.from(this.params.entries());
        for (const [key, value] of sss) {
            paramsObject[key] = value;
        }
        return paramsObject;
    }

    // 设置或更新参数
    static setParam(key: string, value: string) {
        if (!this.params) return;
        this.params.set(key, value);
        RouterMgr.replace(`?${this.params.toString()}`); // 只更新 query
    }

    /**
     * 删除某个参数
     * @param key 参数名
     */
    static deleteParam(key: string): void {
        const newQuery = this.getAllParams;
        // delete newQuery[key];
        RouterMgr.replace(`?${newQuery.toString()}`); // 只更新 query
    }

    /**
     * 清除所有参数
     */
    static clearParams(): void {
        RouterMgr.replace('?');
        this.params = new URLSearchParams('');
    }


}